import React, { useState, useMemo, useEffect } from "react";
import Select from 'react-select'
import countryList from 'react-select-country-list'
import countries from './countries.json'

function RegistrationForm({state, service, index}) {
    const registration = state.applications[index];
    const options = useMemo(() => countryList().getData(), [])

    const handleStateChange = (property, eventObject) => {
        console.log('handle change for '+property + ' at '+index)
        service.handleStateChange(index, property, typeof eventObject === 'object' ? eventObject.target.value : eventObject);
    }

    useEffect(() => {
        countries.map(c => {
            const code = countryList().getValue(c.countryName);
            if (code) {
                countryList().setLabel(code, c.nativeCountryName)
            }
        });
    }, []);


    const [clubOptions, setClubOptions] = useState()

    useEffect(() => {
        let active = true
        load()
        return () => { active = false }

        async function load() {
            const res = await service.getClubOptions()
            if (!active) { return }
            setClubOptions(res)
        }
    }, [])


    return (
        <>
            <h2>Person {index + 1}</h2>
            <p>
                <input className="nameInput" type="text" name="firstname" placeholder="Förnamn"
                       value={registration.firstName}
                       onChange={(e) => {
                           handleStateChange('firstName', e)
                       }} onKeyUp={(e) => {
                    service.handleKeyPress(e)
                }}/>&nbsp;&nbsp;
                <input className="nameInput" type="text" name="lastname" placeholder="Efternamn"
                       value={registration.lastName}
                       onChange={(e) => {
                           handleStateChange('lastName', e)
                       }} onKeyUp={(e) => {
                    service.handleKeyPress(e)
                }}/>
            </p>
<p>
            <Select placeholder="Ange klubb* (krav för tävlingsklass)" options={clubOptions} isClearable
                    value={registration.clubObject}
                    onChange={(c) => {
                        service.handleStateChange(index, 'clubObject', c)
                    }} onKeyUp={(e) => {
                service.handleKeyPress(e)
            }}/>
</p>
            <p>
                <input className="clubInput" type="text" name="club" placeholder="eller ort** om ej klubbmedlem" size={31}
                       disabled={registration.disableClubInput}
                       value={registration.clubInput} onChange={(e) => {
                    handleStateChange('clubInput', e)
                }} onKeyUp={(e) => {
                    service.handleKeyPress(e)
                }}/>
            </p>

            <input type="number" name="birthyear" placeholder="Födelseår" value={registration.birthyear}
                   onChange={(e) => {
                       handleStateChange('birthyear', e)
                   }} step="1" size="8"
                   onKeyUp={(e) => {
                       service.handleKeyPress(e)
                   }}/>
            &nbsp;{registration.birthyear.length != 4 ? '' : (service.isAdult(registration.birthyear) ? 'Vuxen' : 'Ungdom')}
            <p>
                <input type="radio" id={"male" + index}
                       name={"gender" + index}
                       value="male"
                       checked={registration.gender === 'male'}
                       onChange={(e) => {
                           handleStateChange('gender', e)
                       }} onKeyUp={(e) => {
                    service.handleKeyPress(e)
                }}/> <label htmlFor={"male" + index}>Man</label>
                &nbsp;&nbsp;&nbsp;
                <input type="radio" id={"female" + index}
                       name={"gender" + index}
                       value="female"
                       checked={registration.gender === 'female'}
                       onChange={(e) => {
                           handleStateChange('gender', e)
                       }} onKeyUp={(e) => {
                    service.handleKeyPress(e)
                }}/> <label htmlFor={"female" + index}>Kvinna</label>
            </p>

            <Select options={options} value={registration.countryObject} onChange={(c) => {
                service.handleStateChange(index, 'countryObject', c)
            }} onKeyUp={(e) => {
                service.handleKeyPress(e)
            }}/>


            <table className="classChoiceTable">
                <thead>
                <tr key="header1" className="no_bottomline">
                    <th>Klass</th>
                    <th colSpan="2">Pris (SEK)</th>
                </tr>
                <tr key="header2">
                    <th></th>
                    <th>Vuxen</th>
                    <th className="price" width="55">Ungd.</th>
                </tr>
                </thead>
                <tbody>
                {state.classes.map((c, classIndex) => (
                    <tr key={index + '_' + c.id} className={classIndex + 0 < state.classes.length ? '' : 'no_bottomline'}>
                        <td>
                            <input type="radio"
                                   id={c.id + '-' + index}
                                   name={'competitionClass' + index}
                                   value={c.id}
                                   checked={registration.competitionClass === c.id}
                                   onChange={(e) => {
                                       handleStateChange('competitionClass', e)
                                   }} onKeyUp={(e) => {
                                service.handleKeyPress(e)
                            }}/> <label
                            htmlFor={c.id + '-' + index}>{c.name}{c.name !== c.description ? ', ' + c.description : ''}</label>
                        </td>
                        <td className="price">{state.competition.isLate ? c.adultLatePrice : c.adultPrice}</td>
                        <td className="price">{state.competition.isLate ? c.youthLatePrice : c.youthPrice}</td>
                    </tr>
                ))}
                </tbody>
            </table>
            <br/>
            <p>
                <input type="checkbox" id={'bus' + index} disabled={!service.isBussApplyOpen(index)} onChange={(e) => {
                    handleStateChange('bus', e.target.checked)
                }}
                       onKeyUp={(e) => {
                           service.handleKeyPress(e)
                       }}/> <label htmlFor={'bus' + index}>{service.getBusLabel(index)}</label> <span
                style={{float: "right"}}>{state.competition.busFee}&nbsp;</span>
            </p>
            <p>
                <input type="checkbox" id={'noPhoto' + index} onChange={(e) => {
                    handleStateChange('noPhoto', e.target.checked)
                }}
                       onKeyUp={(e) => {
                           service.handleKeyPress(e)
                       }}/> <label htmlFor={'noPhoto' + index}>Vill ej vara med på bild.***</label>
            </p>

            {index > 0 ? (
                <>
                    <div className="rightContent">
                        <button type="button" name="removeRegistration" onClick={(e) => {
                            service.removeRegistration(index)
                        }}>Ta bort person
                        </button>
                    </div>
                    <br/>
                </>
            ) : ''}
        </>
    );
}

export default RegistrationForm;